import React from 'react';
import { Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { SyncIcon } from '../icons';
import { LNA_STATES } from '../hooks/useLocalNetworkAccess';

const LNAStatusBanner = ({ LNAState, requestLNA }) => {
    return (
        <Alert
            severity={LNAState === LNA_STATES.DENIED ? 'error' : 'warning'}
            action={
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    startIcon={<SyncIcon style={{ fontSize: '15px' }} />}
                    onClick={requestLNA}
                >
                    Refresh
                </Button>
            }
        >
            {LNAState === LNA_STATES.DENIED
                ? 'Local Network Access is denied. Please enable it in your browser settings to use the payment terminal.'
                : 'Local Network Access is required to use the payment terminal. Please grant access.'}
        </Alert>
    );
};

export default LNAStatusBanner;
